export class NewsEventModel {
    constructor(public id: number, public path: string, public path_app: string, public news_title: string, public news_content: string, public news_image_caption: string, public news_date_post: string){}
}